import config from '../config/env';

// Load balancer is deprecated - using single API URL from config
// This file is kept for backward compatibility but should not be used
const SERVERS = [config.apiUrl];

const VALID_SERVERS = SERVERS.filter(url => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
});

let currentServerIndex = 0;
const serverHealth = VALID_SERVERS.map(() => ({ healthy: true, failures: 0, lastCheck: Date.now(), responseTime: 0, consecutiveSuccesses: 0 }));

const MAX_FAILURES = 3;
const RECOVERY_TIME = 30000;
const HEALTH_CHECK_INTERVAL = 60000;

export const getNextServer = () => {
  if (VALID_SERVERS.length === 0) throw new Error('No valid servers available');
  return config.apiUrl; // Always return the configured API URL
};

export const markServerFailed = (serverUrl) => {
  const index = VALID_SERVERS.indexOf(serverUrl);
  if (index < 0) return;
  
  const health = serverHealth[index];
  health.failures++;
  health.consecutiveSuccesses = 0;
  health.lastCheck = Date.now();
  
  if (health.failures >= MAX_FAILURES && health.healthy) {
    health.healthy = false;
    setTimeout(() => {
      if (!health.healthy) {
        health.healthy = true;
        health.failures = 0;
      }
    }, RECOVERY_TIME);
  }
};

export const markServerSuccess = (serverUrl, responseTime = 0) => {
  const index = VALID_SERVERS.indexOf(serverUrl);
  if (index < 0) return;
  
  const health = serverHealth[index];
  health.failures = Math.max(0, health.failures - 1);
  health.consecutiveSuccesses++;
  health.responseTime = responseTime;
  health.lastCheck = Date.now();
  
  if (!health.healthy && health.consecutiveSuccesses >= 2) {
    health.healthy = true;
    health.failures = 0;
  }
};

export const getAllServers = () => [config.apiUrl];

export const getServerHealth = () => {
  return VALID_SERVERS.map((server, index) => ({
    url: server,
    healthy: serverHealth[index].healthy,
    failures: serverHealth[index].failures,
    responseTime: serverHealth[index].responseTime,
    lastCheck: new Date(serverHealth[index].lastCheck).toISOString()
  }));
};

export const startHealthCheck = () => {
  setInterval(() => {
    const now = Date.now();
    serverHealth.forEach((health) => {
      if (!health.healthy && now - health.lastCheck > RECOVERY_TIME) {
        health.healthy = true;
        health.failures = 0;
      }
    });
  }, HEALTH_CHECK_INTERVAL);
};

if (process.env.NODE_ENV === 'development') {
  window.__loadBalancer = {
    getHealth: getServerHealth,
    getServers: getAllServers,
    reset: () => serverHealth.forEach(h => { h.healthy = true; h.failures = 0; })
  };
}
